import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: true,
  status: null,
  message: null,
  data: null
};

const peerRequestReducer = createReducer(initialState, {
  USER_PEER_REQUEST_REQ: (state) => {
    state.loading = true;
    state.data = null;
  },
  USER_PEER_REQUEST_SUC: (state, actions) => {
    const payload = actions.payload;
    state.loading = false;
    state.status = payload.status;
    state.message = payload.message;
    state.data = payload.data;
  },
  USER_PEER_REQUEST_ERROR: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = null;
  },
});

export default peerRequestReducer;
